import clsx from 'clsx';
import { useState } from 'react';
import { DynamicSkeleton } from '../../../components/DynamicSkeleton';
import {
  SupportCreateTicket,
  SupportTicketCategory,
} from '../../../types/commonTypes';

interface Props {
  categories: SupportTicketCategory[];
  loading: boolean;
  updateFormField(key: keyof SupportCreateTicket, value: any): void;
}

export const TicketCategories = ({
  categories,
  loading,
  updateFormField,
}: Props) => {
  const [selectedCategory, setSelectedCategory] =
    useState<SupportTicketCategory | null>(null);

  const handleChange = (category: SupportTicketCategory) => {
    setSelectedCategory(category);
    updateFormField('category', category.id);
  };
  return (
    <div className="grid grid-cols-12 justify-content-center items-center gap-2 py-4">
      {categories.length === 0 && loading ? (
        <DynamicSkeleton
          className="col-span-full"
          rowHeight={40}
          containerWidth="100%"
          skeletons={['90%']}
        />
      ) : (
        categories.map((category: SupportTicketCategory, i: number) => (
          <button
            key={`category-option-${i + 1}`}
            className={clsx(
              'col-span-full sm:col-span-4 border rounded-full w-full py-1 disabled:opacity-30 disabled:pointer-events-none',
              {
                'border-error': category.name.toLowerCase() === 'incident',
                'border-[#62D4B9] hover:bg-[#62D4B9] hover:text-white':
                  category.name.toLowerCase() === 'question' ||
                  category.name.toLowerCase() === 'request',
                'bg-error text-white':
                  selectedCategory?.name.toLowerCase() === 'incident' &&
                  selectedCategory.id === category.id,
                'bg-[#62D4B9] text-white':
                  (selectedCategory?.name.toLowerCase() === 'question' ||
                    selectedCategory?.name.toLowerCase() === 'request') &&
                  selectedCategory.id === category.id,
              }
            )}
            onClick={() => handleChange(category)}
            type="button"
            disabled={loading}
          >
            {category.name}
          </button>
        ))
      )}
    </div>
  );
};
